import React, {useState} from "react";
import {
  Container,
  Group,
  Burger,
  Paper,
  Transition,
  Image,
  rem,
  Button,
  Modal,
  HoverCard,
  Center,
  Box,
  Text,
  SimpleGrid,
  Divider,
  Anchor,
  useMantineTheme,
  UnstyledButton,
  ThemeIcon,
  Drawer,
  ScrollArea,
  Collapse,
  Flex,
} from "@mantine/core";
import {useDisclosure} from "@mantine/hooks";
//import {JoinWaitlist} from "../components/JoinWaitlist";
import {colors} from "@fig/libs/client/styles/js/colors";
import {useMediaQuery} from "@mantine/hooks";

import classes from "./Header.module.scss";
import {Link} from "react-router-dom";
import {JoinWaitlist} from "../../modals/JoinWaitlist";
import {IconChevronDown} from "@tabler/icons-react";
import DesktopDropdown from "./components/buttons/DesktopDropdown";
import DesktopButton from "./components/buttons/DesktopButton";
import MobileDropdown from "./components/buttons/MobileDropdown";
import MobileButton from "./components/buttons/MobileButton";

interface HeaderProps {
  links: {
    link?: string | undefined;
    label: string;
    dropdown?: {
      title: string;
      viewAllLink?: string;
      subLinks: {
        link?: string;
        label: string;
        onClick?: any;
        description: string;
        icon: any;
      }[];
      footer: {
        title: string;
        description: string;
        linkLabel: string;
        linkOnClick?: any;
        link?: string;
      };
    };
    onClick?: Function | undefined;
  }[];
  darkMode?: boolean;
  primaryLink?: {link?: string | undefined; label: string; onClick?: Function | undefined};
  hideLogo?: boolean;
}

export default function Header({links, darkMode, primaryLink, hideLogo}: HeaderProps) {
  const [openedBurger, {toggle: toggleBurger, close: closeBurger}] = useDisclosure(false);
  const theme = useMantineTheme();
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const desktopLinks = links.map((link) => {
    if (link.dropdown) {
      return <DesktopDropdown key={link.label} label={link.label} dropdown={link.dropdown} darkMode={darkMode} />;
    } else {
      return <DesktopButton key={link.label} darkMode={darkMode} {...link} />;
    }
  });

  const mobileLinks = links.map((link) => {
    if (link.dropdown) {
      return <MobileDropdown key={link.label} label={link.label} dropdown={link.dropdown} />;
    } else {
      return <MobileButton key={link.label} {...link} />;
    }
  });

  return (
    <div className={classes.root}>
      <Container className={classes.header} size="lg" px="xs">
        {hideLogo !== true ? (
          <Anchor
            href={`https://${process.env.WWW_HOSTNAME}${
              process.env.WWW_PORT_HTTPS ? `:${process.env.WWW_PORT_HTTPS}` : ""
            }`}>
            <Image
              src={darkMode ? "/assets/logo/fig-full-white.png" : "/assets/logo/fig-black.png"}
              className={classes.logo}
              alt={"fig logo"}
            />
          </Anchor>
        ) : (
          <span></span>
        )}
        <Group gap={5} className={classes.links} ta="center">
          {desktopLinks}
        </Group>
        {primaryLink && (
          <Button
            //ml={"auto"}
            // variant="outline"
            radius="xl"
            // ml={rem(30)}
            fw="500"
            size={isSmallScreen ? "sm" : "md"}
            // fs={".06rem"}
            color={darkMode ? "white" : "text"}
            onClick={primaryLink.onClick ? (e) => primaryLink.onClick?.() : undefined}
            renderRoot={primaryLink.link ? (props) => <a href={primaryLink.link} {...props} /> : undefined}
            className={classes.button + " " + (darkMode ? classes.ctaButtonFullBleed : classes.ctaButtonWhite)}>
            {primaryLink.label}
          </Button>
        )}

        <Burger
          opened={openedBurger}
          onClick={toggleBurger}
          className={classes.burger}
          color={darkMode ? "white" : "text"}
          size="sm"
        />

        <Drawer
          opened={openedBurger}
          onClose={closeBurger}
          size="100%"
          padding="md"
          title={
            <Anchor
              href={`https://${process.env.WWW_HOSTNAME}${
                process.env.WWW_PORT_HTTPS ? `:${process.env.WWW_PORT_HTTPS}` : ""
              }`}>
              <Image src={"/assets/logo/fig-black.png"} className={classes.logo} alt={"fig logo"} />
            </Anchor>
          }
          hiddenFrom="md"
          zIndex={1000000}>
          <ScrollArea h={`calc(env(safe-area-inset-top) + 100vh - ${rem(80)})`} mx="-md">
            <Divider mb="sm" />

            <Flex direction={"column"} align={"start"}>
              {mobileLinks}
            </Flex>

            <Divider my="sm" />

            <Group justify="center" grow pb="xl" px="md">
              {primaryLink && (
                <Button
                  //ml={"auto"}
                  variant="outline"
                  radius="xl"
                  fw="500"
                  size="sm"
                  fs={".06rem"}
                  onClick={
                    primaryLink.onClick
                      ? (e) => {
                          closeBurger();
                          primaryLink.onClick?.();
                        }
                      : undefined
                  }
                  renderRoot={primaryLink.link ? (props) => <a href={primaryLink.link} {...props} /> : undefined}
                  className={classes.button + " " + (darkMode ? classes.ctaButtonFullBleed : classes.ctaButtonWhite)}>
                  {primaryLink.label}
                </Button>
              )}
            </Group>
          </ScrollArea>
        </Drawer>
      </Container>
    </div>
  );
}
